import { Router } from "easy-page-router/react";

import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

export default function AppRouter() {
    return <Router
        renderPage={({ path }) => {
            // The 'path' variable is an array of strings representing the URL segments.
            // For example, "/users/123" would be ["users", "123"].
            
            // If the path is empty, we are at the root URL (/).
            if (path.length === 0) return <Index />;
            
                        
            // You can add more routes here, for example:
            // if (path[0] === 'about') return <AboutPage />;
            // if (path[0] === 'users' && path[1]) return <UserPage id={path[1]} />;
            
            // If no routes match, render a 404 Not Found component.
            return <NotFound />;
        }}
    />;
}
